import { get as _get } from 'lodash'

export function extractErrorMessage(error) {
  if (!error) {
    return 'Something went wrong. Please try again.'
  }

  if (error.response) {
    const errors = _get(error, 'response.data.errors')

    if (errors) {
      if (Array.isArray(errors)) {
        return errors.join(' ')
      }

      if (errors.full_messages && Array.isArray(errors.full_messages)) {
        return errors.full_messages.join(' ')
      }

      if (typeof errors === 'string') {
        return errors
      }

      if (typeof errors === 'object') {
        const errorValues = Object.values(errors).flat()
        return errorValues.join(' ')
      }
    }

    const errorMessage = _get(error, 'response.data.error')
    if (errorMessage) {
      return typeof errorMessage === 'string' ? errorMessage : 'An error occurred'
    }

    const { status } = error.response
    if (status === 401) {
      return 'Invalid email or password'
    }
    if (status === 403) {
      return 'You do not have permission to perform this action'
    }
    if (status === 404) {
      return 'Resource not found'
    }
    if (status >= 500) {
      return 'Server error. Please try again later'
    }

    return 'An error occurred. Please try again'
  }

  if (error.request) {
    return 'Network error. Please check your connection and try again'
  }

  if (error.message) {
    return error.message
  }

  return 'Something went wrong. Please try again.'
}
